import React from "react";
import { useSubscribe } from "react-facebook";

type SubscribeProps = Parameters<typeof useSubscribe>;

interface IFacebookSubscribe {
    event: SubscribeProps[0];
    onChange: SubscribeProps[1];
};

function FacebookSubscribe({ event, onChange }: IFacebookSubscribe) {
    useSubscribe(event, onChange);
    return <></>;
};

export default FacebookSubscribe;